import Container from '@/components/atoms/Container'
import Spinner from '@/components/atoms/Spinner'
import { CardProgressCheck } from '@/components/molecules/Admin/Cards/CardProgressCheck'
import cohortsService from '@/services/cohortsService'
import classNames from 'classnames'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc.js'
import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

dayjs.extend(utc)
dayjs.locale('pt-br')

export function Steps() {
	const navigate = useNavigate()

	const { data: progressCheckData, isLoading } =
		cohortsService.getProgressChecks()

	if (isLoading) {
		return (
			<div className='flex h-full justify-center'>
				<Spinner />
			</div>
		)
	}

	if (!progressCheckData?.progressChecks?.length) {
		return (
			<Container>
				<div className='w-full h-max py-4 px-4 flex items-start justify-center bg-[#191122] border border-dashed border-white/10 rounded-xl'>
					<p className='text-base text-white font-medium md:text-center'>
						Nenhum Progress Check disponível no momento
					</p>
				</div>
			</Container>
		)
	}

	if (
		progressCheckData?.progressChecks &&
		progressCheckData?.progressChecks?.length > 0
	) {
		return (
			<Container className='flex flex-col'>
				{progressCheckData?.progressChecks?.map((progressCohort, key) => {
					const endDate = dayjs(progressCohort?.data_final).endOf('day')
					const nextSubmitLimit = progressCohort?.data_ultimo_envio
						? dayjs(progressCohort?.data_ultimo_envio)
								.endOf('day')
								.add(1, 'days')
						: undefined
					const isPast = dayjs().endOf('day').isAfter(endDate)
					const notStart = dayjs()
						.endOf('day')
						.isBefore(dayjs(progressCohort?.data_inicio).endOf('day'))

					return (
						<div
							className={twMerge(
								classNames(
									'flex flex-col gap-10 border-b border-white/10 last-of-type:border-b-0 py-10',
									{ 'opacity-90 pointer-events-none': isPast || notStart }
								)
							)}
						>
							<div
								className={twMerge(
									classNames(
										'flex flex-col md:flex-row gap-6 md:gap-0 justify-between md:items-center',
										{ 'opacity-30 pointer-events-none': isPast || notStart }
									)
								)}
							>
								<div className='flex gap-4 items-center'>
									<div className='flex flex-col gap-1'>
										<span className='text-white/70 font-medium leading-8'>
											{progressCohort.nome}
										</span>
										<p className='text-white text-3xl lg:text-5xl leading-8 font-bold'>
											Progress Check
										</p>
									</div>
								</div>
								<div className='flex gap-4 items-center'>
									<div className='flex flex-col'>
										<span className='text-white font-medium leading-8'>
											Prazo para concluir
										</span>
										<p className='text-white text-xl lg:text-2xl leading-8 font-semibold'>
											{dayjs(endDate)
												.endOf('day')
												.locale('pt-br')
												.format('DD [de] MMMM')}
										</p>
									</div>
								</div>
							</div>
							<div className='flex w-full py-4 md:py-4' key={key}>
								<Container className='px-0 sm:px-0 md:px-0 xl:px-0'>
									<div className='flex flex-col gap-10 w-full'>
										<div
											className={twMerge(
												classNames('flex gap-6 items-center', {
													'opacity-30 pointer-events-none': isPast || notStart,
												})
											)}
										>
											<p className='text-2xl text-white font-medium'>
												Suas tentativas
											</p>
											<span className='text-white/80 font-medium'>
												{progressCohort?.submitted?.length}/
												{progressCohort?.total_tentativas || 3}
											</span>
										</div>
										<div className='grid sm:grid-cols-2 lg:grid-cols-3 max-w-[1060px] gap-4 md:gap-9 lg:gap-7'>
											{Array.from({
												length: progressCohort?.total_tentativas || 3,
											})?.map((_, key) => (
												<CardProgressCheck
													progressCheck={progressCohort}
													stepId={key + 1}
													isPast={isPast}
													nextSubmitLimitStart={nextSubmitLimit}
													notStart={notStart}
													key={key}
													onClick={() =>
														navigate('/curso/progress-check/nivelamento')
													}
												/>
											))}
										</div>
									</div>
								</Container>
							</div>
						</div>
					)
				})}
			</Container>
		)
	}

	return <div></div>
}
